import React, { useMemo } from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";

const BRAND = { pink: "#FF2D83" };

function classNames(...xs) {
  return xs.filter(Boolean).join(" ");
}

export default function AdminTrackerLayout() {
  const location = useLocation();

  const activeTab = useMemo(() => {
    const path = location.pathname;
    if (path.startsWith("/admin/tracker/phone-members")) return "phone-members";
    return "owner-cases";
  }, [location.pathname]);

  const tabs = [
    { key: "owner-cases", label: "Owner Cases", to: "/admin/tracker/owner-cases" },
    { key: "phone-members", label: "Phone Tracker", to: "/admin/tracker/phone-members" },
  ];

  const activeLabel = activeTab === "phone-members" ? "PHONE TRACKER" : "OWNER CASES";

  return (
    <div className="min-w-0">
      <div className="flex items-start justify-between gap-4">
        <div className="min-w-0">
          <h2 className="text-2xl font-bold tracking-tight text-slate-900">Tracker</h2>
          <p className="mt-2 max-w-4xl text-sm text-slate-600">
            Operational tracking for owner follow-ups and phone-list migration. This module is editable, exportable,
            and enriched with live Wayroot database matches so admin can act case by case from one place.
          </p>
        </div>

        <div className="mt-1">
          <div
            className="inline-flex items-center gap-2 border border-slate-200 bg-white px-3 py-1 text-[11px] font-semibold tracking-wide text-slate-600"
            style={{ borderRadius: 8 }}
          >
            <span className="h-2 w-2" style={{ background: BRAND.pink, borderRadius: 2 }} aria-hidden="true" />
            {activeLabel}
          </div>
        </div>
      </div>

      <div className="mt-4 h-px w-full bg-slate-200" />

      <div className="mt-4 mb-6">
        <div className="border border-slate-200 bg-white px-3 py-3" style={{ borderRadius: 8 }}>
          <div className="flex flex-wrap gap-2">
            {tabs.map((tab) => (
              <NavLink
                key={tab.key}
                to={tab.to}
                className={({ isActive }) =>
                  classNames(
                    "inline-flex items-center justify-center px-5 py-2 text-sm font-semibold transition border",
                    isActive
                      ? "bg-slate-900 text-white border-slate-900"
                      : "bg-white text-slate-700 border-slate-200 hover:bg-slate-50"
                  )
                }
                style={{ borderRadius: 8 }}
              >
                {tab.label}
              </NavLink>
            ))}
          </div>
        </div>
      </div>

      <Outlet key={activeTab} />
    </div>
  );
}
